import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FilesService } from './files.service';
import { FilesViewModel } from './filesView.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { FilesDialogComponent } from './files-dialog.component';
import { FilesDialogFileComponent } from './files-dialog-file.component';
import { FilesDialogEditComponent } from './files-dialog-edit.component';
import { FilesDialogDeleteComponent } from './files-dialog-delete.component';
import * as FileSaver from 'file-saver';
import { CoreService } from '../../core/header/core.service';
import { Utils, LocalDB } from '../../shared/utils';
import { FileConst } from './const';
import { CoreComponent } from '../../core/header/core.component';
import { consts, DB_KEY, dummyUrl } from '../../consts';
import { UploadFileComponent } from './upload-file.component';
import { DummyComponent } from '../../shared/dummy.component';
import { FilesDialogDownloadComponent } from './files-dialog-download';
import { FilesDialogMoveComponent } from './files-dialog-move.component';
import { FilesDialogRepairComponent } from './files-dialog-repair.component';
import { UserCompanyService } from '../user/usercompany/usercompany.service';
import { UserCompanyModel } from '../user/usercompany/usercompany.model';
import { OcrHistoryService } from '../ocrHistory/ocrHistory.service';

@Component({
    selector: 'convfact-files',
    templateUrl: './files-list.component.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})

export class FilesListComponent implements OnInit, OnDestroy {
    constructor(
        private coreService: CoreService,
        private filesService: FilesService,
        public dialog: MatDialog,
        public snackBar: MatSnackBar,
        private router: Router,
        private core: CoreComponent,
        public dummy: DummyComponent,
        private userCompanyService: UserCompanyService,
        private ocrHistoryService: OcrHistoryService
    ) { }

    canOCR: boolean = this.core.canOCR;
    isAdmin: boolean = this.core.user ? this.core.user.isAdmin : false;
    dataSource: FilesViewModel;
    length = 0;
    empty = false;
    note: string;
    directory: string;
    path: string;
    ready: boolean;
    searchText: string = '';
    isDragging = false;
    color = 'primary';
    mode = 'determinate';
    storagePercent = 0;
    getZip = false;
    headerTable: any[] = [];

    firstAccess = true;
    getTotalPages = true;
    totalPages = 1;
    actualPage = 1;

    ocrAvailable: number = 0;
    ocrPagesUsed: number = 0;
    ocrPagesTotal: number = 0;
    ocrWindowEnd: Date | null = null;
    autoProcesarFacturas: boolean = false;
    private userCompany: UserCompanyModel | null = null;

    actualDirectoryName: string = '';
    breadcrumbSegments: { label: string; path: string }[] = [];

    get filteredFiles(): any[] {
        if (!this.dataSource?.files) return [];
        const q = this.searchText?.trim().toLowerCase();
        if (!q) return this.dataSource.files;
        return this.dataSource.files.filter(f => f.note?.toLowerCase().includes(q));
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event: DragEvent) {
        if (!event.dataTransfer?.types?.includes('Files')) return;
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = true;
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: DragEvent) {
        const el = event.relatedTarget as HTMLElement;
        if (el && (event.currentTarget as HTMLElement).contains(el)) return;
        this.isDragging = false;
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;
        this.openUploadDialog(files);
    }

    private openUploadDialog(droppedFiles?: FileList) {
        if (!this.dataSource) return;
        this.dialog.open(UploadFileComponent, {
            data: {
                path: this.path,
                storageCapacity: this.dataSource.storageCapacity,
                storageSpent: this.dataSource.storageSpent,
                storageCapacityString: this.dataSource.storageCapacityString,
                storageSpentString: this.dataSource.storageSpentString,
                droppedFiles: droppedFiles ?? null,
            }
        }).afterClosed().subscribe(() => {
            this.cleanDBlocalFiles();
            this.listFiles();
        });
    }

    ocrAll(selectedInvoices: string[]) {
        selectedInvoices.forEach(uid => this.ocr(uid));
    }

    ocr(uid: string) {
        this.displayInfo('Procesando OCR, se le notificará el resultado');
        this.filesService.abbyy(uid).then(result => {
            switch (result) {
                case consts.STATUS_OK: this.displayInfo('OCR enviado a procesar correctamente.'); break;
                case consts.STATUS_FORBIDDEN: this.displayInfo('Su suscripción actual no incluye OCR.'); break;
                case consts.STATUS_INSUFFICIENT_STORAGE: this.displayInfo('No le quedan páginas OCR disponibles en su cuota anual.'); break;
                case consts.STATUS_INTERNAL_ERROR: this.displayInfo('No ha sido posible procesar su petición. Por favor, intentelo de nuevo más tarde.'); break;
            }
            this.listFiles();
            this.getOcrAvailable();
        });
    }

    loadAutoProcesar() {
        this.userCompanyService.loadData().then(data => {
            this.userCompany = data;
            this.autoProcesarFacturas = data.autoProcesarFacturas || false;
        });
    }

    onToggleAutoProcesar() {
        if (!this.userCompany) { return; }
        this.userCompany.autoProcesarFacturas = this.autoProcesarFacturas;
        this.userCompanyService.editData(this.userCompany).then(() => {
            this.displayInfo(this.autoProcesarFacturas
                ? 'Procesado automático activado.'
                : 'Procesado automático desactivado.');
        }).catch(() => {
            this.autoProcesarFacturas = !this.autoProcesarFacturas;
            this.userCompany!.autoProcesarFacturas = this.autoProcesarFacturas;
            this.displayInfo('No se pudo guardar la configuración. Inténtalo de nuevo.');
        });
    }

    getOcrAvailable() {
        this.filesService.getOcrAvailable().then(response => {
            this.ocrAvailable = response;
        });
        this.ocrHistoryService.getSubscriptionParams().then(params => {
            this.ocrPagesUsed = params?.pagesUsed || 0;
            this.ocrPagesTotal = params?.pagesTotal || 0;
            this.ocrWindowEnd = params?.ocrWindowEnd || null;
        }).catch(() => {
            this.ocrPagesTotal = 0;
        });
    }

    deleteAll(selectedInvoices: string[]) {
        Promise.all(selectedInvoices.map(uid => this.filesService.deleteData(uid)))
            .then(() => {
                this.displayInfo('Ficheros eliminados.');
                this.listFiles();
            })
            .catch(() => this.displayInfo('Error al eliminar algunos ficheros.'));
    }

    uploadFile() {
        this.openUploadDialog();
    }

    returnElement(row): void {
        if (row.type == "Directory") {
            return this.goToDirectory(row.note);
        } else {
            this.filesService.returnElement(row.uid).then(response => {
                this.dialog.open(FilesDialogDownloadComponent, {
                    data: { url: response, note: row.note }
                })
            })
        }
    }

    download(uid: string, note: string, isDirectory: boolean, type: string): void {
        if (isDirectory) return;
        switch (type) {
            case 'Image': this.returnFileImage(uid, note); break;
            case 'Word':  this.returnFileWord(uid, note);  break;
            case 'Excel': this.returnFileExcel(uid, note); break;
            case 'PDF':   this.returnFilePdf(uid, note);   break;
            default:      this.returnElement({ uid, type, note }); break;
        }
    }

    returnFileImage(uid: string, note: string): void {
        this.filesService.returnFileImage(uid).then(response => {
            FileSaver.saveAs(response, note + '.png');
        });
    }

    returnFileWord(uid: string, note: string): void {
        this.filesService.returnFileWord(uid).then(response => {
            FileSaver.saveAs(response, note + '.docx');
        });
    }

    returnFileExcel(uid: string, note: string): void {
        this.filesService.returnFileExcel(uid).then(response => {
            FileSaver.saveAs(response, note + '.xlsx');
        });
    }

    returnFilePdf(uid: string, note: string): void {
        this.filesService.returnFilePDF(uid).then(response => {
            FileSaver.saveAs(response, note + '.pdf');
        });
    }

    renameFile(uid: string, isDirectory: boolean, type: string): void {
        const isDirectoryStr = isDirectory ? 'true' : 'false';

        if (this.dataSource.files.find(f => f.uid == uid).system)
            this.displayInfo("Este elemento pertenece a la configuración del sistema y no puede ser modificado")
        else
            this.dialog.open(FilesDialogEditComponent, {
                data: { path: this.path, uid: uid, isDirectory: isDirectoryStr, type: type }
            }).afterClosed().subscribe(() => this.listFiles());
    }

    openDialog(): void {
        this.dialog.open(FilesDialogComponent, {
            width: '440px',
            maxWidth: '95vw',
            data: { path: this.path }
        }).afterClosed().subscribe(() => this.listFiles());
    }

    openDialogFile(): void {
        this.dialog.open(FilesDialogFileComponent, {
            data: {
                path: this.path,
                storageCapacity: this.dataSource.storageCapacity,
                storageSpent: this.dataSource.storageSpent,
                storageCapacityString: this.dataSource.storageCapacityString,
                storageSpentString: this.dataSource.storageSpentString
            }
        }).afterClosed().subscribe(() => {
            this.cleanDBlocalFiles();
            this.listFiles();
        });
    }

    public delete(uid: string): void {
        const elementFinded = this.dataSource.files.find(f => f.uid === uid);

        if (!elementFinded) {
            this.displayInfo('No se ha encontrado el fichero/directorio.');
            return;
        }

        if (elementFinded.system) {
            this.displayInfo('Este elemento pertenece a la configuración del sistema y no puede ser borrado');
            return;
        }

        const isDir = elementFinded.isDirectory;
        const message = isDir
            ? '¿Seguro que quiere eliminar este directorio y todo su contenido?'
            : '¿Seguro que quiere eliminar este fichero?';

        this.dialog.open(FilesDialogDeleteComponent, {
            data: { message }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (!confirmed) return;
            this.filesService.deleteData(elementFinded.uid)
                .then((responseMessage: string) => {
                    this.displayInfo(responseMessage);
                    this.listFiles();
                })
                .catch(() => {
                    this.displayInfo(isDir
                        ? 'Ha ocurrido un error al intentar eliminar el directorio.'
                        : 'Ha ocurrido un error al intentar eliminar el fichero.');
                });
        });
    }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 7500;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    createDirectory() {
        this.filesService.createDirectory(this.directory, this.path).then(response => {
            this.displayInfo(response);
        });
    }

    goToDirectory(path: string) {
        this.getTotalPages = true;
        LocalDB.Save(DB_KEY.GET_TOTAL_PAGES, this.getTotalPages);
        this.returnToIndex(path);
    }

    comeBack(): void {
        this.getTotalPages = true;
        LocalDB.Save(DB_KEY.GET_TOTAL_PAGES, this.getTotalPages);
        const parentPath = decodeURI(this.path).substring(0, decodeURI(this.path).lastIndexOf('/'));
        this.dummy.redirectTo(parentPath || 'files');
    }

    navigateToBreadcrumb(path: string): void {
        this.getTotalPages = true;
        LocalDB.Save(DB_KEY.GET_TOTAL_PAGES, this.getTotalPages);
        this.dummy.redirectTo(path);
    }

    private onChangePage(event) {
        this.actualPage = event;
        this.listFiles();
        this.getOcrAvailable();
    }

    listFiles() {
        const self = this;

        self.ready = false;

        self.path = self.router.url.substr(1);
        self.dataSource = new FilesViewModel();
        self.dataSource.files = [];

        this.setActualDirectoryName(self.path);

        this.filesService.getList(this.path, this.firstAccess, this.canOCR, this.getTotalPages, this.actualPage).then(
            data => {
                self.dataSource.files.length = 0;
                self.dataSource.files = data.files;
                self.ready = true;

                if (self.firstAccess) {
                    self.dataSource = data;
                    this.storagePercent = Utils.GetPercent(this.dataSource.storageSpent, this.dataSource.storageCapacity);
                    self.firstAccess = false;
                    this.saveDBlocalFiles(data);
                } else {
                    this.loadDBlocalFiles(self);
                }

                if (self.getTotalPages) {
                    self.getTotalPages = false;
                    self.dataSource.totalPages = data.totalPages;
                    self.totalPages = data.totalPages;
                    self.saveDBlocalFilesPages(data);
                } else {
                    self.loadDBlocalFilesPages(self);
                }

                self.dataSource.actualPage = data.actualPage;
                self.actualPage = data.actualPage;

                if (data.files.length === 0) {
                    this.empty = true;
                } else {
                    this.empty = false;
                }

            });
    }

    returnToIndex = function (path: string) {
        const currentUrl = decodeURI(this.router.url + '/' + path);
        this.dummy.redirectTo(currentUrl);
    };

    ngOnInit() {
        this.firstAccess = LocalDB.Load(DB_KEY.FIRST_ACCESS);
        this.getTotalPages = LocalDB.Load(DB_KEY.GET_TOTAL_PAGES);

        if (this.firstAccess == null)
            this.firstAccess = true;

        if (this.getTotalPages == null)
            this.getTotalPages = true;

        if (this.canOCR) {
            this.headerTable = FileConst.headerTableWithOCR;
        } else {
            this.headerTable = FileConst.headerTableWithoutOCR;
        }

        this.path = decodeURI(this.router.url.substr(1));

        this.coreService.setName(this.path);
        this.listFiles();
        this.getOcrAvailable();
        this.loadAutoProcesar();
    }

    cleanDBlocalFiles() {
        LocalDB.RemoveForFiles();
        this.firstAccess = true;
    }

    saveDBlocalFiles(data) {
        LocalDB.Save(DB_KEY.STORAGE_SPENT, data.storageSpent);
        LocalDB.Save(DB_KEY.STORAGE_SPENT_STRING, data.storageSpentString);

        LocalDB.Save(DB_KEY.STORAGE_CAPACITY, data.storageCapacity);
        LocalDB.Save(DB_KEY.STORAGE_CAPACITY_STRING, data.storageCapacityString);

        LocalDB.Save(DB_KEY.STORAGE_PERCENT, this.storagePercent);
        LocalDB.Save(DB_KEY.FIRST_ACCESS, this.firstAccess);
    }

    loadDBlocalFiles(self) {
        self.dataSource.storageSpent = LocalDB.Load(DB_KEY.STORAGE_SPENT);
        self.dataSource.storageSpentString = LocalDB.Load(DB_KEY.STORAGE_SPENT_STRING);

        self.dataSource.storageCapacity = LocalDB.Load(DB_KEY.STORAGE_CAPACITY);
        self.dataSource.storageCapacityString = LocalDB.Load(DB_KEY.STORAGE_CAPACITY_STRING);

        this.storagePercent = LocalDB.Load(DB_KEY.STORAGE_PERCENT);
    }

    saveDBlocalFilesPages(data) {
        LocalDB.Save(DB_KEY.GET_TOTAL_PAGES, this.getTotalPages);
        LocalDB.Save(DB_KEY.TOTAL_PAGES, this.totalPages);
    }

    loadDBlocalFilesPages(self) {
        self.getTotalPages = LocalDB.Load(DB_KEY.GET_TOTAL_PAGES);
        self.totalPages = LocalDB.Load(DB_KEY.TOTAL_PAGES);
        self.dataSource.totalPages = self.totalPages;
    }

    private setActualDirectoryName(path: string): void {
        const decoded = decodeURI(path);
        const parts = decoded.split('/');
        // parts[0] is 'files' (root)
        this.breadcrumbSegments = parts.map((label, i) => ({
            label,
            path: parts.slice(0, i + 1).join('/'),
        }));

        this.actualDirectoryName = decoded.substring(decoded.indexOf('/') + 1);
        this.actualDirectoryName = this.actualDirectoryName.replace(/\//g, ' > ');
    }

    ngOnDestroy() {
        if (this.router.url != dummyUrl) {
            LocalDB.RemovePagesForFiles();
        }
    }

    copyTo(uid: string): void {
        this.dialog.open(FilesDialogMoveComponent, {
            data: { originUid: uid, isCopy: true }
        }).afterClosed().subscribe((destPath: string) => {
            if (!destPath) { return; }
            this.displayInfo('Copiando fichero...');
            this.filesService.moveOrCopyFile({ uid, destPath, move: false }).subscribe({
                next: res => { this.displayInfo(res.message); this.listFiles(); },
                error: () => this.displayInfo('Ha ocurrido un error al intentar copiar el fichero/directorio.'),
            });
        });
    }

    openRepairDialog(): void {
        this.dialog.open(FilesDialogRepairComponent, {
            width: '600px'
        });
    }

    moveTo(uid: string, isDirectory: boolean, type: string): void {
        this.dialog.open(FilesDialogMoveComponent, {
            data: { originUid: uid, isCopy: false, currentPath: this.path }
        }).afterClosed().subscribe((destPath: string) => {
            if (!destPath) { return; }
            this.displayInfo('Moviendo fichero/directorio...');
            this.filesService.moveOrCopyFile({ uid, destPath, move: true }).subscribe({
                next: res => { this.displayInfo(res.message); this.listFiles(); },
                error: () => this.displayInfo('Ha ocurrido un error al intentar mover el fichero/directorio.'),
            });
        });
    }

    public trackByIndex(i: number) { return i; }
}
